import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import i18n from "../../il8n/il8n";
import { setSectionDynamicFieldList } from "../../redux/dynamicFieldSlice";
import { setActive } from "../../redux/routerSlice";
import { getTValue } from "../other/label";

export function NextButton() {
  const activeSectionId = useSelector(
    (state) => state.routerData.activeSectionId
  );
  const formType = useSelector((state) => state.routerData.formType);
  const history = useHistory();
  const sectionList = useSelector((state) => state.routerData.sectionList);

  return (
    <Button
      className="pull-right"
      style={{ margin: 5 }}
      label="Next"
      onClick={(event) =>
        nextTab(activeSectionId, formType, history, sectionList)
      }
    />
  );
}

export function PrevButton() {
  const activeSectionId = useSelector(
    (state) => state.routerData.activeSectionId
  );
  const formType = useSelector((state) => state.routerData.formType);
  const history = useHistory();
  const sectionList = useSelector((state) => state.routerData.sectionList);

  return (
    <Button
      label="Back"
      style={{ margin: 5 }}
      onClick={(event) =>
        prevTab(activeSectionId, formType, history, sectionList)
      }
    />
  );
}

export function nextTab(id, formType, history, sectionList) {
  console.log(id, formType, history);
  let flag;
  for (let route of sectionList) {
    if (id === route.id) {
      flag = true;
    } else if (flag && (!route.type || route.type === formType)) {
      history.push(route.route);
      break;
    }
  }
}

export function prevTab(id, formType, history, sectionList) {
  let proute;
  for (let route of sectionList) {
    if (id === route.id) break;
    else if (!route.type || route.type === formType) proute = route;
  }

  if (proute) history.push(proute.route);
}

const url = "";

const KycSideBar = ({ match, router }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const path = location.pathname;
  const formType = useSelector((state) => state.routerData.formType);
  const completeSet = useSelector((state) => state.routerData.completeSet);
  const sectionList = useSelector((state) => state.routerData.sectionList);
  const dispatch = useDispatch();
  return (
    <div id="kycProgressBar" className="p-col-12 p-md-3">
      <div className="Ksidebar">
        <img className="sidebar-logo" src="/logo-white.png" />
        <ul>
          {sectionList
            .filter((route) => !route.status || route.status === "E")
            .map((route) => {
              const isActive = path === route.route;
              if (isActive) {
                dispatch(setActive(route.id));
                dispatch(setSectionDynamicFieldList(route.id));
              }
              const isComplete = completeSet.has(route.id);
              return (
                <li>
                  <Link
                    className={
                      "kyc-progress-menu" + (isActive ? " active" : "")
                    }
                    to={route.route}
                    onClick={() => {
                      dispatch(setActive(route.id));
                      dispatch(setSectionDynamicFieldList(route.id));
                    }}
                  >
                    {isActive && (
                      <i className={"pi pi-arrow-right keep-left"}></i>
                    )}
                    <i className={`pi ${route.icon}`}></i>{" "}
                    {getTValue(i18n, route.text, route.textNep)}
                    {isComplete && (
                      <i className="pi pi-check very-bold-icon ml-3"></i>
                    )}
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
      <div className="sidebar-copyright">
        {/* Powered By PCS */}
        <LanguageBar />
      </div>
    </div>
  );
};

const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
};

const LanguageBar = () => {
  return (
    <div>
      <a
        className="lang-link-button"
        href="#"
        onClick={() => changeLanguage("np")}
      >
        Nepali
      </a>{" "}
      |{" "}
      <a
        className="lang-link-button"
        href="#"
        onClick={() => changeLanguage("en")}
      >
        English
      </a>
    </div>
  );
};

export default KycSideBar;
